<template>
	<v-dialog v-model="dialog" max-width="800" scrollable>
		<!-- <template v-slot:activator="{ props: activatorProps }">
			<slot name="activator" :props="activatorProps">
				<v-btn
					v-bind="activatorProps"
					text="Оферта"
					variant="outlined"
					color="indigo"
				></v-btn>
			</slot>
		</template> -->

		<template v-slot:default="{ isActive }">
			<v-card>
				<template v-slot:title>
					<v-toolbar density="compact" flat color="transparent">
						<v-toolbar-title class="font-weight-bold">Страхове повідомлення</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon="mdi-close" @click="isActive.value=false"></v-btn>
					</v-toolbar>
				</template>
				

				<template v-slot:text>
					<v-form ref="form">
						<v-row dense class="mt-3">
							<v-col cols="12" md="6">
								<v-select
									v-model="item.insurance.type"
									:items="insurancetypes"
									item-title="name"
									item-value="id"
									label="Вид страхування"
									variant="outlined"
									return-object
								></v-select>
							</v-col>

							<v-col cols="12" md="6">
								<v-select
									v-model="item.status"
									:items="statuses"
									item-title="name"
									item-value="id"
									label="Статус"
									variant="outlined"
									return-object
								></v-select>
							</v-col>

							<v-col cols="12">
								<v-text-field
									v-model="item.number"
									label="Номер страхового повідомлення"
									variant="outlined"
									maxlength="12"
									:rules="[rules.required]"
									@keydown.ctrl.z="item.number=12345"
								></v-text-field>
							</v-col>
							<v-col cols="12" v-if="['auto'].includes(direction)">
								<v-text-field
									v-model="item.vehicle.number"
									label="Номер автомобіля"
									variant="outlined"
									maxlength="12"
									:rules="[rules.required]"
									@keydown.ctrl.z="item.vehicle.number='AA1234BB'"
								></v-text-field>
							</v-col>
						</v-row>

						<v-row dense>
							<v-col cols="12">
								<v-divider></v-divider>
								<div class="text-subtitle-1">Заявник</div>
							</v-col>
							<v-col cols="12" md="6">
								<v-select
									v-model="item.applicant.role"
									:items="applicantroles"
									item-title="name"
									item-value="id"
									label="Роль заявника"
									variant="outlined"
									return-object
								></v-select>
							</v-col>
							<v-col cols="12" md="6">
								<v-select
									v-model="item.applicant.type"
									:items="applicanttypes"
									item-title="name"
									item-value="id"
									label="Тип заявника"
									variant="outlined"
									return-object
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.applicant.name"
									label="Прізвище, ім'я, по батькові"
									placeholder="Іваненко Іван Іванович"
									variant="outlined"
									:rules="[rules.required]"
									@keydown.ctrl.z="item.ApplicantName='Іваненко Іван Іванович'"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field
									v-model="item.applicant.phone"
									label="Нормер телефону"
									placeholder="+38 ХХХ ХХХ ХХ ХХ"
									variant="outlined"
									:rules="[rules.required,rules.phone]"
									@keydown.ctrl.z="item.applicant.phone='+380963332211'"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field
									v-model="item.applicant.email"
									label="E-mail"
									placeholder="example@mail.com"
									variant="outlined"
									:rules="[rules.required,rules.email]"
									@keydown.ctrl.z="item.applicant.email='example@mail.com'"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.applicant.address"
									label="Адреса проживання (для офіційного листування)"
									variant="outlined"
									@keydown.ctrl.z="item.applicant.address='Київ'"
								></v-text-field>
							</v-col>
						</v-row>

						<v-row dense v-if="item.status.code =='clarification'">
							<v-col cols="12">
								<v-divider></v-divider>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.documents"
									:items="clarifications"
									item-title="type.name"
									item-value="type.id"
									label="Уточнення інформації"
									variant="outlined"
									return-object
									multiple
									:rules="[rules.required]"
								></v-select>
							</v-col>
						</v-row>

						<v-row dense v-if="item.status.code =='signing'">
							<v-col cols="12">
								<v-divider class="my-3"></v-divider>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.documents"
									:items="signdocuments"
									item-title="type.name"
									item-value="type.id"
									label="Документи для підписання"
									variant="outlined"
									return-object
									multiple
									:rules="[rules.required]"
								></v-select>
							</v-col>
						</v-row>

						
						
					</v-form>
				</template>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text="Скасувати"
						variant="text"
						@click="isActive.value=false"
					></v-btn>

					<v-btn
						color="primary"
						text="Створити"
						variant="flat"
						@click="onOk"
					></v-btn>
				</v-card-actions>
			</v-card>

			<v-overlay v-model="loading"  class="d-flex justify-center align-center">
				<v-progress-circular indeterminate size="64"></v-progress-circular>
			</v-overlay>
		</template>
	</v-dialog>
</template>

<script>
import axios from 'axios'
export default {
	name: 'Dialog::Claim',
	components: { },
	data: () => ({
		//dialog: false,
		loading: false,

		item: {
			number: "1111",
			insurance: {
				type: null
			},
			status: null,
			vehicle: {
				number: "AA1111AA"
			},
			applicant: {
				name: "Іваненко Іван Іванович",
				phone: "0963332211",
				email: "example@mail.com",
				address: "Київ",
				isOwner: true,
				isAgreeCircumstances: true,
				isLifeHelthHarmed: false,
				type: null,
				role: null,
			},
			documents: [],
			signdocuments: []
		},
		
		insurancetypes: [
			{id: 1, code: "auto", name: "Автотранспортне страхування", description: ""},
			{id: 2, code: "health", name: "Здоров'я", description: ""},
			{id: 3, code: "tourism", name: "Туризм", description: ""},
			{id: 4, code: "property", name: "Майно", description: ""},
		],

		statuses: [
			{id: 1, code: "application", name: "Надання інформації", description: "Процес надання інформації клієнтом через web-додаток"},
			{id: 2, code: "completion", name: "Інформацію надано", description: "Завершення процесу надання інформації клієнтом через web-додаток"},
			{id: 3, code: "processing", name: "Обробка документів", description: "Обробка документів реєстратором справи"},
			{id: 4, code: "clarification", name: "Уточнення інформації", description: "Реєстратор здійснив первинну перевірку документів і ініціював уточнення інформації"},
			{id: 5, code: "accepted", name: "Документи прийняті", description: "Документи перевірені та узгоджені куратором, він формує фінальну смс заявнику-потерпілому про те, що всі документи прийняті."},
			{id: 6, code: "signing", name: "Підписання документів", description: "Заявнику формується драфт документу для ознайомлення та підпису."},
			{id: 7, code: "signed", name: "Документи підписано", description: "Документи підписано Заявником."},
			{id: 8, code: "closed", name: "Справа закрита", description: "Справа закрита."},
		],

		applicanttypes: [
			{id: 1, code: "f", name: "Фізична особа"},
			{id: 2, code: "fop", name: "ФОП"},
			{id: 3, code: "u", name: "Юридична особа"}
		],

		applicantroles: [
			{id: 1, code: "insured", name: "Страхувальник"},
			//{id: 2, code: "victim", name: "Потерпілий"},
			{id: 2, code: "injured", name: "Потерпілий"}
		],

		clarifications: [
			{
				type: { id: 1, code: 'RegistrationCertificate', name: "Свідоцтво про реєстрацію ТЗ", description: "" },
				files: []
			},
			{
				type: { id: 2, code: 'DriversLicense', name: "Посвідчення водія", description: "" },
				files: []
			},
			{
				type: { id: 3, code: 'EuroProtocol', name: "Європротокол", description: "" },
				files: []
			},
			{
				type: { id: 4, code: 'PoliceDocument', name: "Документи поліції", description: "" },
				files: []
			},
			{
				type: { id: 5, code: 'OtherDocument', name: "Інші документи", description: "" },
				files: []
			},
			{
				type: { id: 6, code: 'EDRPOU', name: "Витяг з ЄДРПОУ", description: "" },
				files: []
			},
			{
				type: { id: 7, code: 'CourtOrder', name: "Постанова суду", description: "" },
				files: []
			},
			{
				type: { id: 8, code: 'TravelDocument', name: "Подорожній лист/наказ про закріплення ТЗ", description: "" },
				files: []
			},
			{
				type: { id: 9, code: 'PropertyRightsDocument', name: "Документи права на власність", description: "" },
				files: []
			},
			{
				type: { id: 10, code: 'Passport', name: "Паспорт", description: "" },
				files: []
			},
			{
				type: { id: 11, code: 'Inn', name: "Ідентифікаційний номер", description: "" },
				files: []
			},
			{
				type: { id: 12, code: 'InsurancePolicy', name: "Страховий поліс", description: "" },
				files: []
			},
			{
				type: { id: 13, code: 'AccidentScene', name: "Фото/відео з місця ДТП", description: "" },
				files: []
			}
		],

		signdocuments: [
			{ 
				id: 1,
				type: { id: 14, code: 'IncidentReport', name: "Повідомлення про випадок", description: "" },
				files: [
					{ name: "Повідомлення про випадок", originalName: "Повідомлення про випадок", extension: "pdf"}
				]
			},
			{ 
				id: 2,
				type: { id: 15,code: 'PaymentApplication', name: "Заява на виплату", description: ""},
			 	files: [
					{ name: "Заява на виплату", originalName: "Заява на виплату", extension: "pdf"}
				]
			},
			{ 
				id: 3,
				type: { id: 16, code: 'PVZReport', name: "Повідомлення для ПВЗ", description: ""},
				files: [
					{ name: "Повідомлення для ПВЗ", originalName: "Повідомлення для ПВЗ", extension: "pdf"}
				]
			},
		],
	}),

	props: {
		modelValue: 		{ type: Boolean, default: false},
	},

 	computed: {
		dialog: {
			get() 		{ return this.modelValue },
			set(val) 	{ this.$emit('update:modelValue', val) }
		},

		direction() {
			let result = 'auto'
			switch(this.item.insurance.type.code) {
				case 'auto': result = 'auto'; break;
				case 'health': result = 'health'; break;
				case 'tourism': result = 'tourism'; break;
				case 'property': result = 'property'; break;
			}

			return result
		},

		rules() {
			return {
				required: (value) => !!value || this.$vuetify.locale.t('$vuetify.rule.required'),
				mustBeSelected: (value) => typeof(value) === "undefined" || value === null || value?.id>0 || this.$vuetify.locale.t('$vuetify.rule.mustBeSelected'),
				
				code: (value) => {
					const pattern = /^([a-zA-Z'\-]+)/
					return (value === null || value.length == 0 || value.length > 32 || pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.code', [128])
				},
				name: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\-]+)/
					return (value && value.length <= 10 && pattern.test(value)) || 'Name is not correct'
					//return value === null || ( value.length <= 10 && pattern.test(value)) || 'Name is not correct'
				},
				date: (value) => {
					//console.log('form.mixin', 'rules.date', 'value', value)
					return (value === null || value?.length == 0 || moment(value, "DD.MM.YYYY", true).isValid() || moment(value, "YYYY-MM-DD", true).isValid()) || 'Date is not correct'
				},

				datetime: (value) => {
					return (value === null || value.length == 0 || moment(value, "YYYY-MM-DDTHH:mm", true).isValid()) || 'Date is not correct'
				},

				email: (value) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || this.$vuetify.locale.t('$vuetify.rule.email')//'Некоректний e-mail.'
				},
				phone: (value) => {
					const pattern = /^\+?3?8?(0\d{9})$/
					//return (value === null || value?.length == 0 || pattern.test(value)) || 'Номер телефону не вірний (+380961112233)'
					return pattern.test(value) || 'Номер телефону не вірний (+380961112233)'
				},
				personsname: (value) => {
					const pattern = /^([a-zA-Zа-яА-ЯЇї'\- ]+)/
					return (value && value.length <= 10 && pattern.test(value)) || this.$vuetify.locale.t('$vuetify.rule.personsname')//'Name is not correct'
				},

				ofertaagree: (value) => value === true || this.$vuetify.locale.t('$vuetify.rule.required'),
				ClaimNumber: (value) => !!value && value.length === 5 || "OTP must be 6 digits.",
			}
		},
	},

	created() {
		this.item.insurance.type = this.insurancetypes[0]
		this.item.status = this.statuses[0]
		this.item.applicant.type = this.applicanttypes[0]
		this.item.applicant.role = this.applicantroles[0]
	},

	methods: {
		onOk() {
			console.log(this.$options.name, 'onOk','item', this.item)

			var that = this
			this.$refs.form.validate().then(({ valid: isValid }) => {
				if(isValid) {
					this.loading = true
					axios.post(`/claim/create`, this.item).then(response => {
						//console.log(that.$options.name, 'onOk','response.data', response.data)
						that.dialog = false
					}, error => {
						console.log('error', error)
						//this.showMessage(error)
					}).finally(() => {
						this.loading = false
					});
				}
			})
		},
	},
}
</script>